import React, { useMemo } from 'react';
import ListItem from './ListItem';
import UploadListItemStyle from './style';
const UploadList = (props) => {
    const { items } = props;
    const renderItems = useMemo(() => {
        return items.map((item, index) => (React.createElement(ListItem, { key: index, item: item })));
    }, [items]);
    return React.createElement(UploadListItemStyle, null, renderItems);
};
export default UploadList;
//# sourceMappingURL=index.js.map